import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import {
  Alert,
  Col,
  Row,
  Spinner,
  Form,
  Button,
  ButtonGroup,
  Dropdown,
} from "react-bootstrap";
import { getOrgs } from "../../../redux/organization/actions";
import CustomNavbar from "../../../components/CustomNavbar";
import {
  getFuncUsersData,
  getGlobalFuncUserInfo,
} from "../../../redux/func_ficha_empleados/actions";
import SidebarDashboard from "../../../components/SidebarDashboard";
import CustomPagint from "../../../components/CustomPagint";

const OrgsforStaffInventory = (props) => {
  const filters = [
    { num: 1, id: "codigo", desc: "Código de empleado" },
    { num: 2, id: "nombre", desc: "Nombre de empleado" },
    { num: 3, id: "centro_costo", desc: "Centro de costo" },
    { num: 4, id: "funcion", desc: "Función" },
    { num: 5, id: "puesto", desc: "Puesto" },
    { num: 6, id: "unidad_organizativa", desc: "Unidad organizativa" },
  ];

  const [show, setShow] = useState(false);
  //Redux
  const dispatch = useDispatch();
  const [filter, setFilter] = useState("");
  const data = useSelector((store) => store.orgs.orgs);
  const dataLenght = useSelector((store) => store.funcTabEmployeed.fichaLength);
  const loading = useSelector((store) => store.orgs.loading);
  const userRoles = useSelector((store) => store.auth.userRoles);
  const [Search, setSearch] = useState(false);
  const [offset, setOffset] = useState(0);
  const [limit, setLimit] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);
  const [tipoBusqueda, setTipoBusqueda] = useState(filters[0]);
  const pages = Math.ceil(dataLenght / limit);

  useEffect(() => {
    dispatch(getOrgs(parseInt(props.match.params.id)));
  }, [dispatch, props.match.params.id]);

  const onShowSidebar = () => setShow(show ? false : true);

  const onSearch = (e) => {
    e.preventDefault();
    if (!filter.trim()) {
      return;
    }

    //props.history.push(parseInt(props.match.params.id) === 1 ? `/Inventario-de-personal/0/Búsqueda global/2/${filter}` : `/func-inventario-de-personal/0/Búsqueda global/2/${filter}`);
    props.history.push(
      `/inventario-de-personal/0/Búsqueda global/2/${filter}/${props.match.params.id}/${tipoBusqueda.num}`
    );
  };

  const seeAll = () => {
    props.history.push(
      `/inventario-de-personal/0/Búsqueda global/2/${filter} /allregisters00/${filters[0].num}`
    );

    // const oSearch = '';
    // setSearch(oSearch);
    // const oOffset = 0;
    // setOffset(oOffset);
    // setCurrentPage(1);
    // if(parseInt(props.match.params.searchtype) === 1){
    //   getAFuncUsersData(oOffset, limit, oSearch);
    // }else{
    //   getAGlobalFuncUserInfo(oOffset, limit, oSearch);
    // }
  };
  let orgs = [];
  if (data.length > 0 && userRoles.includes("alta_direccion")) {
    data.map((item) => {
      if (
        item.codigo !== "2400" &&
        item.codigo !== "1570" &&
        item.codigo !== "1550" &&
        item.codigo !== "1510" &&
        item.codigo !== "1500"
      ) {
        orgs = [...orgs, item];
      }
    });
  } else {
    orgs = data;
  }
  const getAFuncUsersData = (offs = offset, lim = limit, filt = filter) =>
    dispatch(
      getFuncUsersData(
        {
          orga: props.match.params.id,
          offset: offs,
          limit: lim,
          filter: filt,
          activo:
            userRoles.includes("jefe") || userRoles.includes("alta_direccion")
              ? "Activo"
              : "",
        },
        parseInt(props.match.params.type)
      )
    );
  const getAGlobalFuncUserInfo = (offs = offset, lim = limit) =>
    dispatch(
      getGlobalFuncUserInfo(
        {
          offset: offs,
          limit: lim,

          // activo: userRoles.includes('jefe') || userRoles.includes('alta_direccion') ? 'Activo' : '',
          all_empleados: true,
        },
        parseInt(props.match.params.type)
      )
    );

  return (
    <>
      <CustomNavbar type={"dashboard"} onShowSidebar={onShowSidebar} />
      <SidebarDashboard show={show} onShowSidebar={onShowSidebar} />
      <div className="custom-wrapper">
        <div className="container-fluid">
          <div className="my-1 pl-md-4 pr-md-3 pl-2 pr-1 d-flex flex-wrap justify-content-between align-items-center">
            <h5 className="font-weight-bold text-uppercase">
              ¿Qué empresa desea revisar?
            </h5>
            <div className="my-1 pl-md-4 pr-md-3 pl-2 pr-1 pl-2 d-flex flex-wrap justify-content-between align-items-center">
              {/* <Form className="ml-auto" onSubmit={onSearch}>
              <Form.Control
                onChange={ e => setFilter(e.target.value)}
                placeholder="Buscar"
                className="rounded-pill form-control-sm"
                type="search"></Form.Control>
            </Form> */}
              <Form className="ml-auto" onSubmit={onSearch}>
                <Row className="justify-content-end align-items-center flex-nowrap">
                  <Col>
                    <h6>
                      <b>Búsqueda por: {tipoBusqueda.desc}</b>
                    </h6>
                  </Col>
                  <Col xs="auto">
                    <Form.Control
                      onChange={(e) => setFilter(e.target.value)}
                      placeholder="Buscar"
                      className="rounded-pill form-control-sm"
                      type="search"
                    ></Form.Control>
                  </Col>
                  <Col xs="auto">
                    <ButtonGroup>
                      <Dropdown className="mx-1">
                        <Dropdown.Toggle
                          variant="light"
                          className="btn-sm font rounded-pill"
                        >
                          <i className="material-icons">filter_list</i>
                        </Dropdown.Toggle>
                        <Dropdown.Menu>
                          {filters.map((item) => (
                            <Dropdown.Item
                              onClick={() => setTipoBusqueda(item)}
                              key={item.id}
                            >
                              {item.desc}
                            </Dropdown.Item>
                          ))}
                        </Dropdown.Menu>
                      </Dropdown>
                    </ButtonGroup>
                  </Col>
                </Row>
              </Form>
              {userRoles.length > 0 && userRoles.includes("alta_direccion") ? (
                <Button
                  variant="light"
                  className="rounded-pill ml-2"
                  onClick={() => seeAll()}
                >
                  <i className="material-icons">list</i>
                </Button>
              ) : null}
            </div>
          </div>
          <div className="px-2">
            <hr />
          </div>
          {loading ? (
            <div className="d-flex justify-content-center mt-4">
              <Spinner
                animation="border"
                role="status"
                className="d-flex justify-content-center"
              />
            </div>
          ) : data.length === 0 ? (
            <Alert className="my-4" variant="info">
              Aún no hay empresas registradas para mostrar los empleados
              correspondientes a la misma
            </Alert>
          ) : (
            <Row>
              {orgs.map((item) => (
                <Col md="3" className="mb-2">
                  <Link
                    style={{ height: "100px" }}
                    //to={ parseInt(props.match.params.id) === 1 ? `/Inventario-de-personal/${item.id}/${item.nombre}/1/00` : `/func-inventario-de-personal/${item.id}/${item.nombre}/1/00`}
                    to={`/inventario-de-personal/${item.id}/${item.nombre}/1/00/${props.match.params.id}/${filters[0].num}`}
                    className="btn btn-primary d-flex justify-content-center align-items-center"
                  >
                    {item.nombre}
                  </Link>
                </Col>
              ))}
            </Row>
          )}
        </div>
      </div>
    </>
  );
};

export default OrgsforStaffInventory;
